<template>
        <b-card
        header="Indicadores Generales"
        header-tag="header"
    >
        <div slot="header">
            <app-sub-title text="Indicadores Generales"></app-sub-title>
        </div>
        <b-card-body>
            <b-container fluid>
                <b-row>
                    <b-col cols="12" md="4">
                        <app-figure title="Total Asignaciones">
                            {{ figures.total }}
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Total Resueltas" :status="figures.total === figures.totalAnswered? 'success':'normal'">
                            {{ figures.totalAnswered }}
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Efectividad" :status="getEfectivenessStatus()">
                            {{ figures.efectiveness | decimal(0) }} %
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Desviación (días)" :status="getDeviationStatus()">
                            {{ !!figures.deviation? figures.deviation: 0 | decimal(2) }}
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Resueltas Vencidas" :status="getResolvedOverdueStatus()">
                            {{ figures.totalOverdue }} ({{ !!figures.totalAnswered? (figures.totalOverdue / figures.totalAnswered * 100): 0 | decimal(2) }} %)
                        </app-figure>
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-figure title="Abiertas Vencidas" :status="!!figures.totalOpenOverdue? 'error':'normal'">
                            {{ figures.totalOpenOverdue }}
                        </app-figure>
                    </b-col>
                </b-row>
            </b-container>
        </b-card-body>
    </b-card>
</template>
<script>
import Figure from '../../../../../UI/Reports/Figure';
export default {
    name: 'pqr_user_figures_general',
    components: {
        appFigure: Figure
    },
    props: ['figures'],
    methods: {
        getResolvedOverdueStatus() {
            if(!this.figures.totalAnswered) return 'normal';
            const ind = this.figures.totalOverdue / this.figures.totalAnswered * 100;

            if(ind === 0) return 'success';

            return ind > 10?'error':'normal';
        },
        getDeviationStatus() {

            if(!this.figures.deviation || parseFloat(this.figures.deviation) === 0) return 'success';

            return parseFloat(this.figures.deviation) > 2? 'error': 'normal';
        },
        getEfectivenessStatus() {
            const efectiveness = parseFloat(this.figures.efectiveness);
            if(efectiveness === parseFloat(100)) return 'success';

            return efectiveness < 80? 'error': 'normal';
        }
    }
}
</script>